import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { EventSendeurService } from '../../../shared/event-sendeur.service';
import { NbToastrService, NbDialogRef, NbDialogService } from '@nebular/theme';
import { MediathequeComponent } from '../../../shared/mediatheque/mediatheque.component';
import { DomSanitizer } from '@angular/platform-browser';

import {plainToClass} from 'class-transformer';
import { Img } from '../../../shared/data/img';
import { config } from 'rxjs';
import { Config } from '../../../config/config';
import { NbIconLibraries } from '@nebular/theme';
import { Page } from '../../../shared/data/page';
import { ApiService } from '../../../shared/api.service';

@Component({
  selector: 'ngx-edit-page',
  templateUrl: './edit-page.component.html',
  styleUrls: ['./edit-page.component.scss']
})
export class EditPageComponent implements OnInit {
  @Input() id: number;
  model;

  /* description;

  slug;
  titre;
  datePublish; */
  heure = "15";
  minute = "22";
  page = new Page;
  hideButon = false;
  hideLoader = true;
  //photoSelected: Img; 

  url: string

  config = Config;
  
  // isPublish = false;

  selectedItems = [];
  dropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'short_title',
    selectAllText: 'Selectionner tous',
    unSelectAllText: 'Déselectionner tout',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };

  pages: any[];

  constructor(iconsLibrary: NbIconLibraries, private sanitizer: DomSanitizer,private dialogService: NbDialogService,protected dialogRef: NbDialogRef<EditPageComponent>,private apiService:ApiService, private router:Router,private sendeurService:EventSendeurService, public toastr:NbToastrService ) { 
  
    this.url = Config.urlserveur;
    iconsLibrary.registerFontPack('fa', { packClass: 'fa', iconClassPrefix: 'fa' });
    iconsLibrary.registerFontPack('far', { packClass: 'far', iconClassPrefix: 'fa' });
    iconsLibrary.registerFontPack('ion', { iconClassPrefix: 'ion' });

    this.model = this.page.converDatePublishToNgbDateStruct;

    this.getPage();
  
  }

  ngOnInit() {

    this.sendeurService.image.next(null);
  
    if(this.id !== 0)
    this. getOnePage();
  
    // console.log(this.model);

    this.sendeurService.image.asObservable().subscribe(data =>{
      // this.imageChoisie = this.sanitizer.bypassSecurityTrustResourceUrl(data);
      // this.photoSelected = plainToClass(Img, data as object);
      this.page.photo = plainToClass(Img, data as object);

      // console.log(this.photoSelected);
      
      // alert("");
      
    })

    this.sendeurService.fichier.asObservable().subscribe(data =>{
      // this.imageChoisie = this.sanitizer.bypassSecurityTrustResourceUrl(data);
      // this.photoSelected = plainToClass(Img, data as object);
      this.page.fichier = plainToClass(Img, data as object);

      // console.log(this.photoSelected);
      
      // alert("");
      
    })

   
  }

  getPage(){

    this.apiService.getAllPageProvider().subscribe(data =>{

      // une categorie ne doit pas avoir comme parent elle-même ou un de ces fils

      const pages: Page[] = plainToClass(Page, data);

      if( this.page.id !== 0) {

        const index = pages.findIndex( item =>item.id === this.page.id);
        if(index > -1)
        pages.splice(index,1);

      }

      if( this.page.id !== 0 && this.page.descendant !== undefined && this.page.descendant !== null) {

        this.page.descendant.forEach(element => {

          const index = pages.findIndex( item =>item.id === element);
          if(index > -1)
          pages.splice(index,1);
          
        });

      }

      this.pages = pages;


    },(err) =>{

      if(err.error.code ===401){
        this.toastr.danger("Authentification non autorisé");
      }

      if(err.error.code ===500){
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
      }
    
    })
  }

  updatePage(){

      console.log(this.model)
      // return;

      this.hideButon = true;
      this.hideLoader = false;
    /* var data = JSON.parse(localStorage.getItem("image"));
    if(!JSON.parse(localStorage.getItem("image"))){
    
      this.toastr.danger(" vous devez choisir une image");
      this.hideButon = false;
      this.hideLoader = true;
      return false;
    } */
    if(this.model!== undefined){

      this.page.date_publish = {
       "date": {
          "year": this.model.year,
          "month": this.model.month,
          "day": this.model.day 
       },
       "time": {
          "hour": 0,
          "minute": 0
       }
     }

    }


  //  this.datePublish = this.model.year +'/'+this.model.month+'/'+this.model.day

   
  /*  console.log(data);
   console.log(data.baseUrl);
   this.photoSelected.path = data.path;
  this.photoSelected.baseUrl = data.baseUrl;
   this.photoSelected.hash = data.hash;
   this.photoSelected.mime = data.mime;
   this.photoSelected.name = data.name;
   this.photoSelected.phash = data.phash;
   this.photoSelected.size = data.size;
   this.photoSelected.tmb = data.tmb;
   this.photoSelected.ts = data.ts;
   this.photoSelected.url = data.url; */
  
   
   if(this.id !== 0) {

    this.apiService.updatePageProvider(this.page).subscribe(data =>{
      console.log(data);
      this.dialogRef.close();
      this.sendeurService.fichier.next(null);
      this.toastr.success("mise à jour réussie","success");
      localStorage.removeItem("image");
      this.sendeurService.sendPageEvent(6);
    },(err) =>{
      console.log(err);
      this.toastr.danger(" echec de mise à jour , remplissez tous les champs ")
      this.hideButon = false;
      this.hideLoader = true;
      if(err.error.code ===401){
       localStorage.clear();
       window.location.reload();
       let link2 = ['/login'];
       this.router.navigate(link2);
     }
 
     if(err.error.code ===500){
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
     
    })

   } else {

    this.apiService.addPageProvider(this.page).subscribe(data =>{
      console.log(data);
      this.dialogRef.close();
      this.toastr.success("page crée avec success", "success");
      localStorage.removeItem("fichier");
      this.sendeurService.fichier.next(null);
      this.sendeurService.sendPageEvent(5);
    },(err) =>{

     this.hideButon = false;
     this.toastr.danger("il se peut qu'une page porte déjà le meme nom", "erreur")
      console.log(err);
      if(err.error.code ===401){
       localStorage.clear();
       window.location.reload();
       let link2 = ['/login'];
       this.router.navigate(link2);
     }
 
     if(err.error.code ===500){
      this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
  
    })

   }
   
  }


  selectImage(){
    // localStorage.setItem("photo","image");
    this.dialogService.open(MediathequeComponent, {context: { mime: 'image'}});
  }

  selectFile(){
    // localStorage.setItem("photo","image");
    this.dialogService.open(MediathequeComponent, {context: { mime: 'all'}});
  }

  deleteFile(){
    // localStorage.setItem("photo","image");
    this.page.fichier = null;
  }


  getOnePage(){
    this.apiService.getOnePageProvider(this.id).subscribe(data =>{

      this.page = plainToClass(Page, data as object);
      this.model = this.page.converDatePublishToNgbDateStruct;
      if( this.page.parent_page !== null )
      this.selectedItems = [this.page.parent_page];

      // console.log(this.page.parent_page);
      // console.log(this.page.converDatePublishToNgbDateStruct);
      
    },(err) =>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
    })
  }


  cancel(){
    this.dialogRef.close();
    this.sendeurService.fichier.next(null);
  }

  close(){
    this.dialogRef.close();
    this.sendeurService.fichier.next(null);
  }

  onItemSelect(item: any) {

    //this.target = item.id.toString();

    this.page.parent_page = item
   
  }

  
  onItemDeSelect(items: any){
    // this.target = '';
    this.page.parent_page = null
  }

  onSelectAll(items: any) {
    
  }

  onDeSelectAll($event){
    
  }

  onUnSelectAll(){
    
  }

  onDropDownClose($event){
    
  }


  
  



}
